export const frSurveys = {
    // SURVEYS

    'surveys.title': 'Sondages',
    'surveys.name': 'Sondage', // type label

    'surveys.list.pageTitle': 'Sondages',
    'surveys.list.sectionTitle': 'Sondages',
    'surveys.list.emptyLabel': 'Aucun sondage pour le moment.',
    'surveys.list.actions.addSurvey': 'Créer un sondage',
    'surveys.list.table.emptyLabel': "Il n'y a pas de sondage pour le moment.",
    'surveys.list.table.header.info': 'Informations',
    'surveys.list.table.header.owner': 'Propriétaire',
    'surveys.list.table.header.nbShops': 'Nombre de centres',
    'surveys.list.table.header.endDate': "Date d'échéance",
    'surveys.list.table.header.type': 'Type',
    'surveys.list.table.state.draft': 'Brouillon',
    'surveys.list.table.state.drafts': 'Brouillon',
    'surveys.list.table.state.published': 'Publié',
    'surveys.list.table.state.unpublished': 'Annulé',
    'surveys.list.table.state.finished': 'Terminé',
    'surveys.list.table.filters.favoriteShops': 'Mes centres favoris',
    'surveys.list.table.filters.apply': 'Appliquer',
    'surveys.list.table.filters.label.state': 'État :',

    // SURVEYS >> CREATE

    'surveys.create.pageTitle': 'Création sondage',
    'surveys.create.actions.cancelCreation': 'Annuler la création',
    'surveys.create.actions.addTheSurvey': 'Enregistrer',
    'surveys.create.input.name': 'Saisissez ici le nom du sondage *',
    'surveys.create.input.code': 'Saisissez ici le code du sondage',
    'surveys.create.input.floatingLabelName': 'Nom',
    'surveys.create.input.floatingLabelCode': 'Code',
    'surveys.create.tabs.info': 'Informations',
    'surveys.create.tabs.questions': 'Questions',
    'surveys.create.tabs.audience': 'Audience',
    'surveys.create.tabs.notifications': 'Notifications',
    'surveys.create.tabs.audiences.treeTitle': 'Choix sectorisation',
    'surveys.create.tabs.informations.generalSectionTitle': 'Informations générales',
    'surveys.create.tabs.informations.publishSectionTitle': 'Publication',
    'surveys.create.tabs.informations.inputs.floatingLabelEndDate': "Date d'échéance",
    'surveys.create.tabs.informations.inputs.endDate': "Sélectionnez une date d'échéance",
    'surveys.create.tabs.informations.inputs.description':
        'Saisissez ici la description du sondage',
    'surveys.create.tabs.informations.inputs.floatingLabelDescription': 'Description',
    'surveys.create.tabs.informations.inputs.questionCode':
        'Saisissez ici un code dédidé à cette question',
    'surveys.create.tabs.informations.inputs.floatingLabelQuestionCode': 'Code question',
    'surveys.create.tabs.informations.questions.title': 'Titre',
    'surveys.create.tabs.informations.questions.titleHintText': 'Saisir ici un titre',
    'surveys.create.tabs.informations.questions.question': 'Question',
    'surveys.create.tabs.informations.questions.questionHintText': 'Saisir ici la question',
    'surveys.create.tabs.informations.questions.description': 'Description',
    'surveys.create.tabs.informations.questions.descriptionHintText': 'Saisir ici une description',
    'surveys.create.tabs.informations.questions.uniqueChoice': 'QCU',
    'surveys.create.tabs.informations.questions.possibleAnswer': 'Réponse possible',
    'surveys.create.tabs.informations.questions.possibleAnswerHintText': 'Saisir ici la réponse',
    'surveys.create.tabs.informations.questions.externalReference': 'Ref. externe',
    'surveys.create.tabs.informations.questions.externalReferenceHintText':
        'Saisir ici la référence',
    'surveys.create.tabs.informations.questions.xAnswersPossible': 'réponses possibles',
    'surveys.create.tabs.informations.questions.xAnswerPossible': 'réponse possible',
    'surveys.create.tabs.informations.questions.nextquestion': 'Question suivante',
    'surveys.create.tabs.informations.questions.addAnswer': 'Ajouter une réponse',
    'surveys.create.tabs.informations.questions.gotoend': 'Aller à la fin',
    'surveys.create.tabs.informations.questions.gotoquestion': 'Passer à la question',
    'surveys.create.tabs.informations.questions.addQuestion': 'Ajouter une question',
    'surveys.create.tabs.informations.questions.type.label': 'Type de question',
    'surveys.create.tabs.informations.questions.type.undefined': 'Indéfini',
    'surveys.create.tabs.informations.questions.type.singlechoice': 'QCU',
    'surveys.create.tabs.informations.questions.type.multiplechoice': 'QCM',
    'surveys.create.tabs.informations.questions.type.text': 'Texte',
    'surveys.create.tabs.informations.select.owner.sectionTitle': 'Propriétaire',
    'surveys.create.tabs.informations.select.owner.title': 'Sélectionnez le propriètre du sondage',
    'surveys.create.tabs.informations.select.owner.floatingLabelTitle': 'Propriétaire',
    'surveys.create.tabs.informations.select.owner.listTitle': 'Choix du propriétaire',
    'surveys.create.tabs.informations.select.owner.listInputLabel': 'Chercher un utilisateur siège',
    'surveys.create.tabs.informations.select.owner.listCloseLabel': 'Fermer',
    'surveys.create.tabs.informations.select.docs.addPhoto': 'Ajouter une photo',
    'surveys.create.tabs.informations.select.docs.addPhotoLabel': 'Visuel photo',
    'surveys.create.tabs.informations.select.docs.title': 'Joindre un fichier PDF',
    'surveys.create.tabs.informations.select.docs.label': 'Fichier PDF',
    'surveys.create.tabs.informations.select.docs.btn': 'Parcourir',
    'surveys.create.tabs.informations.select.docs.imageUrl': "URL de l'image",
    'surveys.create.tabs.informations.select.docs.load': 'Charger',
    'surveys.create.tabs.informations.select.docs.hintHttp': 'http://...',
    'surveys.create.tabs.informations.select.docs.cancelLabel': 'Annuler',
    'surveys.create.tabs.informations.publish.publishBtn': 'Publier',
    'surveys.create.tabs.informations.publish.cancelBtn': 'Annuler la publication',
    'surveys.create.tabs.notifs.time': '--',
    'surveys.create.tabs.notifs.floatingLabelTime': 'Heure de la relance',
    'surveys.create.tabs.notifs.date': '--',
    'surveys.create.tabs.notifs.floatingLabelDate': 'Date de la relance',
    'surveys.create.tabs.notifs.dateSwitch': 'Date unique',
    'surveys.create.tabs.notifs.recursiveTime': '--',
    'surveys.create.tabs.notifs.floatingLabelRecursiveTime': 'Heure de répétition',
    'surveys.create.tabs.notifs.recursiveTimeSwitch': 'Répétition',
    'surveys.create.tabs.notifs.repeat': '--',
    'surveys.create.tabs.notifs.floatingLabelRepeat': 'Tous les XX jours',
    'surveys.create.tabs.notifs.noneLabel': 'Aucune relance',
    'surveys.create.tabs.notifs.autoSend': 'Relance automatique',

    // SURVEYS >> DETAILS
    'surveys.details.pageTitle': 'Détails sondage',
    'surveys.details.actions.save': 'Enregistrer',
    'surveys.details.actions.remove': 'Supprimer',
    'surveys.details.actions.previous': 'Sondages',
    'surveys.details.input.name': 'Saisissez ici le nom du sondage *',
    'surveys.details.input.code': 'Saisissez ici le code du sondage',
    'surveys.details.input.floatingLabelName': 'Nom',
    'surveys.details.input.floatingLabelCode': 'Code',
    'surveys.details.dialog.title': 'Suppression du sondage',
    'surveys.details.dialog.content': 'Êtes-vous sûr de vouloir supprimer ce sondage ?',
    'surveys.details.dialog.validateLabel': 'Supprimer',
    'surveys.details.dialog.cancelLabel': 'Annuler',
    'surveys.details.tabs.info': 'Informations',
    'surveys.details.tabs.questions': 'Questions',
    'surveys.details.tabs.audience': 'Audience',
    'surveys.details.tabs.notifications': 'Notifications',
    'surveys.details.tabs.audiences.treeTitle': 'Choix sectorisation',
    'surveys.details.tabs.informations.generalSectionTitle': 'Informations générales',
    'surveys.details.tabs.informations.publishSectionTitle': 'Publication',
    'surveys.details.tabs.informations.inputs.floatingLabelEndDate': "Date d'échéance",
    'surveys.details.tabs.informations.inputs.endDate': "Sélectionnez une date d'échéance",
    'surveys.details.tabs.informations.inputs.description':
        'Saisissez ici la description du sondage',
    'surveys.details.tabs.informations.inputs.floatingLabelDescription': 'Description',
    'surveys.details.tabs.informations.inputs.questionCode':
        'Saisissez ici un code dédidé à cette question',
    'surveys.details.tabs.informations.inputs.floatingLabelQuestionCode': 'Code question',
    'surveys.details.tabs.informations.questions.title': 'Titre',
    'surveys.details.tabs.informations.questions.titleHintText': 'Saisir ici un titre',
    'surveys.details.tabs.informations.questions.question': 'Question',
    'surveys.details.tabs.informations.questions.questionHintText': 'Saisir ici la question',
    'surveys.details.tabs.informations.questions.description': 'Description',
    'surveys.details.tabs.informations.questions.descriptionHintText': 'Saisir ici une description',
    'surveys.details.tabs.informations.questions.uniqueChoice': 'QCU',
    'surveys.details.tabs.informations.questions.possibleAnswer': 'Réponse possible',
    'surveys.details.tabs.informations.questions.possibleAnswerHintText': 'Saisir ici la réponse',
    'surveys.details.tabs.informations.questions.externalReference': 'Ref. externe',
    'surveys.details.tabs.informations.questions.externalReferenceHintText':
        'Saisir ici la référence',
    'surveys.details.tabs.informations.questions.xAnswersPossible': 'réponses possibles',
    'surveys.details.tabs.informations.questions.xAnswerPossible': 'réponse possible',
    'surveys.details.tabs.informations.questions.nextquestion': 'Question suivante',
    'surveys.details.tabs.informations.questions.gotoend': 'Aller à la fin',
    'surveys.details.tabs.informations.questions.gotoquestion': 'Passer à la question',
    'surveys.details.tabs.informations.questions.type.label': 'Type de question',
    'surveys.details.tabs.informations.questions.type.undefined': 'Indéfini',
    'surveys.details.tabs.informations.questions.type.singlechoice': 'QCU',
    'surveys.details.tabs.informations.questions.type.multiplechoice': 'QCM',
    'surveys.details.tabs.informations.questions.type.text': 'Texte',
    'surveys.details.tabs.informations.select.owner.sectionTitle': 'Propriétaire',
    'surveys.details.tabs.informations.select.owner.title': 'Sélectionnez le propriètre du sondage',
    'surveys.details.tabs.informations.select.owner.floatingLabelTitle': 'Propriétaire',
    'surveys.details.tabs.informations.select.owner.listTitle': 'Choix du propriétaire',
    'surveys.details.tabs.informations.select.owner.listInputLabel':
        'Chercher un utilisateur siège',
    'surveys.details.tabs.informations.select.owner.listCloseLabel': 'Fermer',
    'surveys.details.tabs.informations.select.docs.addPhoto': 'Ajouter une photo',
    'surveys.details.tabs.informations.select.docs.addPhotoLabel': 'Visuel photo',
    'surveys.details.tabs.informations.select.docs.title': 'Joindre un fichier PDF',
    'surveys.details.tabs.informations.select.docs.label': 'Fichier PDF',
    'surveys.details.tabs.informations.select.docs.btn': 'Parcourir',
    'surveys.details.tabs.informations.select.docs.imageUrl': "URL de l'image",
    'surveys.details.tabs.informations.select.docs.load': 'Charger',
    'surveys.details.tabs.informations.select.docs.hintHttp': 'http://...',
    'surveys.details.tabs.informations.select.docs.cancelLabel': 'Annuler',
    'surveys.details.tabs.informations.select.publisher.sectionTitle': 'Publier en tant que',
    'surveys.details.tabs.informations.select.publisher.title': 'Sélectionnez le nom du publieur',
    'surveys.details.tabs.informations.select.publisher.floatingLabelTitle': 'Publier en tant que',
    'surveys.details.tabs.informations.select.publisher.listTitle': 'Choix du publieur',
    'surveys.details.tabs.informations.select.publisher.listInputLabel':
        'Chercher un utilisateur ou une équipe',
    'surveys.details.tabs.informations.select.publisher.listCloseLabel': 'Fermer',
    'surveys.details.tabs.informations.publish.publishBtn': 'Publier',
    'surveys.details.tabs.informations.publish.cancelBtn': 'Annuler la publication',
    'surveys.details.tabs.notifs.time': '--',
    'surveys.details.tabs.notifs.floatingLabelTime': 'Heure de la relance',
    'surveys.details.tabs.notifs.date': '--',
    'surveys.details.tabs.notifs.floatingLabelDate': 'Date de la relance',
    'surveys.details.tabs.notifs.dateSwitch': 'Date unique',
    'surveys.details.tabs.notifs.recursiveTime': '--',
    'surveys.details.tabs.notifs.floatingLabelRecursiveTime': 'Heure de répétition',
    'surveys.details.tabs.notifs.recursiveTimeSwitch': 'Répétition',
    'surveys.details.tabs.notifs.repeat': '--',
    'surveys.details.tabs.notifs.floatingLabelRepeat': 'Tous les XX jours',
    'surveys.details.tabs.notifs.noneLabel': 'Aucune relance',
    'surveys.details.tabs.notifs.autoSend': 'Relance automatique',
    'surveys.details.tabs.notifs.manualSend': 'Relance manuelle',
    'surveys.details.tabs.notifs.manualInfo':
        "Envoyer une notification de relance aux collaborateurs qui n'ont pas encore consulté le sondage",
    'surveys.details.tabs.notifs.manualBtnlabel': 'Relancer',
    'surveys.details.tabs.notifs.notifsHistoryEmpty': "Pas d'historique de notifications",
    'surveys.details.tabs.notifs.tableTitle': 'Historique des notifications',
    'surveys.details.tabs.results.export': 'Export Excel',
    'surveys.details.tabs.results.seeResult': 'Visualiser la réponse',
    'surveys.details.tabs.results.answersFrom': 'Réponse(s) du centre',
    'surveys.details.tabs.results.tableHeader.shop': 'Centre',
    'surveys.details.tabs.results.tableHeader.shops': 'Centres',
    'surveys.details.tabs.results.tableHeader.user': 'Collaborateur',
    'surveys.details.tabs.results.tableHeader.state': 'État de réponse',
    'surveys.details.tabs.results.tableHeader.orderedQuantity': 'Quantité commandée',
    'surveys.details.tabs.results.state.replied': 'Répondu',
    'surveys.details.tabs.results.state.notreplied': 'Non répondu',
    'surveys.details.tabs.results.state.draft': 'Brouillon',
    'surveys.details.tabs.results.filters.date.from': 'Du',
    'surveys.details.tabs.results.filters.date.to': 'Au',
    'surveys.details.tabs.results.filters.date.btn': 'Appliquer',
    'surveys.details.tabs.results.filters.label.from': 'Commandé après le',
    'surveys.details.tabs.results.filters.label.to': 'Commandé avant le',
    'surveys.details.tabs.results.filters.label.bothFirst': 'Commandé entre le',
    'surveys.details.tabs.results.filters.label.bothSecond': 'et le',
    'surveys.details.tabs.results.emptyLabel': 'Aucun résultat pour le moment.',

    //TOAST ERRORS
    'toast.apiErrors.SURVEY_ALREADY_PUBLISHED': 'Ce sondage est déjà publié',
    'toast.apiErrors.SURVEY_MISSING_AUDIENCE':
        "Aucune audience n'est définie pour ce sondage, il ne peut pas être publié",
    'toast.apiErrors.SURVEY_MISSING_END_DATE':
        "La date d'échéance n'est pas définie pour ce sondage, il ne peut pas être publié",
    'toast.apiErrors.SURVEY_MISSING_TITLE':
        "Le titre n'est pas défini pour ce sondage, il ne peut pas être publié",
    'toast.apiErrors.SURVEY_CANT_DELETE_PUBLISHED':
        'Impossible de supprimer un sondage qui a été publié',

    //* SURVEYS AUDIENCES DEFINITION
    'surveys.audiences.def.title':
        'Ce sondage peut être répondu par les responsables des centres uniquement ou par certains rôles des collaborateurs.',
    'surveys.audiences.def.subtitle': "Sélectionnez votre type d'audience :",

    'surveys.audiences.def.type.shop.title': '1 résultat attendu par centre',
    'surveys.audiences.def.type.shop.subtitle': '(Seul un responsable peut répondre)',

    'surveys.audiences.def.type.collaborator.title': 'Plusieurs résultats attendus par centre',
    'surveys.audiences.def.type.collaborator.subtitle':
        '(Tous les rôles des collaborateurs sélectionnés peuvent répondre au sondage)',

    //* DUPLICATION DU CONTENU
    'surveys.clone.dialog.title': 'Copie du sondage',
    'surveys.clone.dialog.content': 'Voulez-vous créer une copie de ce Sondage ?',

    'surveys.questions.answersNeeded.error': "Impossible d'enregistrer ou de publier ce sondage, le nombre de réponses attendues est incohérent pour une ou plusieurs questions",
};
